import React, { useState } from "react";
import { useGenericFormValidator } from "../../../util/genericFormValidator";
import { isValidCPF } from "../../../util/validators";
import { patternsValidators } from "../../../model/enum";
import { useNavigate } from "react-router-dom";
import { formatDateForApi } from "../../../util/mask";
import { useRedux } from '../../../redux/hook/useRedux'
import { actionRegisterUser } from "../../../redux/user/actions";
import { Alert } from "../../../util/Alert";
import { SendToken } from "../../../service/controller/LoanController";

export const useRegister = () => {
    const maxSteps = 4;
    const { dispatch } = useRedux()
    const navigate = useNavigate();
    const [currentStep, setCurrentStep] = useState(1);
    const [isRequiredToken, setIsRequiredToken] = useState(false);
    const [solicitationNumber, setSolicitationNumber] = useState('');
    const initialForm = {
        cpf: '',
        fullName: '',
        dateOfBirth: '',
        email: '',
        phone: '',
        nb: '',
        city: '',
        uf: '',
        typePerson: '', // FGTS ou INSS
    };
    const inputsPersonalData = [
        { label: 'Cpf', field: 'cpf', placeholder: 'XXX.XXX.XXX-XX' },
        { label: 'Nome Completo', field: 'fullName', placeholder: 'Seu Nome Completo' },
        { label: 'Data de nascimento', field: 'dateOfBirth', placeholder: 'XX/XX/XXXX' },
        { label: 'E-mail', field: 'email', placeholder: 'seu@email.com' },
        { label: 'Telefone', field: 'phone', placeholder: '(XX) 9XXXX-XXXX' },
        { label: 'Matrícula', field: 'nb', placeholder: 'XXXXXXXXXX', maxLength: 10 },
        { label: 'Cidade', field: 'city', placeholder: 'XXXXXXXXXX' },
        { label: 'UF', field: 'uf', placeholder: 'XX', maxLength: 2 },
    ];
    const personalDataFormRules = {
        cpf: {
            required: true,
            custom: (value) => isValidCPF(value) ? null : 'CPF inválido'
        },
        fullName: {
            required: true,
        },
        dateOfBirth: {
            pattern: patternsValidators.dateOfBirth,
            required: true,
            message: 'Data inválida',
        },
        email: {
            required: true,
            pattern: patternsValidators.email,
            message: 'Email inválido',
        },
        phone: {
            required: true,
            pattern: patternsValidators.phone,
            message: 'Telefone inválido',
        },
    };
    const { form, errors, handleChange, validate, setForm } = useGenericFormValidator(initialForm, personalDataFormRules);


    const handleNextStep = () => {
        setCurrentStep(currentStep + 1);
    }

    const handleSubmit = () => {
        onSubmitPersonalData();
    }

    const checkSMSToken = (token) => {
        SendToken(token, solicitationNumber, () => {
            Alert('Token validado com sucesso','Por favor realize o login para continuar');
            navigate('/login');
        })
    }

    const onSubmitPersonalData = () => {
        if (validate()) {
            handleNextStep();
        }
    }

    const onSubmitPassword = (password) => {
        if (form.nb && (!form.city || !form.uf)) {
            Alert('Matrícula informada, obrigatório informar a Cidade e Estado onde você reside!', '', false, false, true);
            return;
        }

        if (validate()) {
            const submitForm = {
                nb: form.nb,
                cpf: form.cpf,
                fullName: form.fullName,
                email: form.email,
                phone: form.phone,
                dateOfBirth: formatDateForApi(form.dateOfBirth),
                password: password,
                typePerson: form.typePerson,
                nb: form.nb,
                city: form.city,
                uf: form.uf
            }

            dispatch(actionRegisterUser(submitForm, (isRequiredToken, solicitationNumber) => {
                if (!isRequiredToken) {
                    Alert('Cadastro realizado com sucesso! por favor realiza o login.');
                    navigate('/login');
                } else {
                    setIsRequiredToken(true);
                    setSolicitationNumber(solicitationNumber);
                }
            }))
        }
    }

    const StepProgress = () => {
        const percent = (currentStep / maxSteps) * 100;
        return (
            <React.Fragment>
                <div className="w-full h-2 bg-gray-300 rounded-full overflow-hidden">
                    <div
                        className="h-full bg-purple-900 rounded-full transition-all duration-500"
                        style={{ width: `${percent}%` }}
                    />
                </div>
            </React.Fragment>
        );
    };

    const onSetTypePerson = (typePerson) => {
        setForm({ ...form, typePerson });
        handleNextStep();
    }

    return {
        StepProgress,
        handleSubmit,
        currentStep,
        handleChange,
        form,
        errors,
        inputsPersonalData,
        checkSMSToken,
        onSubmitPassword,
        navigate,
        setCurrentStep,
        onSetTypePerson,
        isRequiredToken
    }
}